<template>
  <div class="pdfView">
    <!-- <div class="tools">
      <button :title="'基础按钮'" @click.stop="prePage" class="mr10">
        上一页
      </button>
      <button :title="'基础按钮'" @click.stop="nextPage" class="mr10">
        下一页
      </button>
      <div class="page mr10">{{ pageNum }}/{{ pageTotalNum }}</div>
      <button :title="'基础按钮'" @click.stop="clock" class="mr10">
        顺时针
      </button>
      <button :title="'基础按钮'" @click.stop="counterClock" class="mr10">
        逆时针
      </button>
    </div>
    <pdf
      ref="pdf"
      :src="pdfUrl"
      :page="pageNum"
      :rotate="pageRotate"
      @progress="loadedRatio = $event"
      @page-loaded="pageLoaded($event)"
      @num-pages="pageTotalNum = $event"
      @error="pdfError($event)"
      @link-clicked="page = $event"
    >
    </pdf> -->
    <iframe :src="pdfUrl" frameborder="0" width="100%" height="500px"></iframe>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { getPreviewUrl } from "@/api/user";
export default {
  name: "previewPdf",
  components: {
    pdf,
  },
  props: {
    pdfFile: {
      type: Object,
      default: () => {},
    },
    funcs: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      loadedRatio: 0,
      curPageNum: 0,
      pdfUrl: "",
    };
  },
  watch: {
    pdfFile: {
      handler(file) {
        console.log(file, "pppp");
        let _this = this;
        if (file) {
          _this.getPdfUrl(file);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted: function () {},
  methods: {
    async getPdfUrl(file) {
      // let res = await fileDownload(file.url.split("=")[1]);
      let res = await getPreviewUrl(file.fileName);
      console.log(res);
      this.pdfUrl = res.result
      // this.pdfUrl = window.webkitURL.createObjectURL(res.data);
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {}
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {}
      }
      return url;
    },
    // 上一页函数，
    prePage() {
      var page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    // 下一页函数
    nextPage() {
      var page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    // 页面顺时针翻转90度。
    clock() {
      this.pageRotate += 90;
    },
    // 页面逆时针翻转90度。
    counterClock() {
      this.pageRotate -= 90;
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.curPageNum = e;
    },
    // 其他的一些回调函数。
    pdfError(error) {
      console.error(error);
    },
  },
};
</script>
<style lang="scss" scoped>

/deep/ .el-dialog{
  width: 80%;
}
.pdfView {
  .tools {
    display: flex;
    .mr10 {
      margin-right: 10px;
    }
  }
}
</style>
